<template>
	<div class="purchase-order-setting">
		<div class="fx-header">
			<p>常购单档案</p>
		</div>
		<Search @handleSearch="handleSearch"/>
		<div class="features-btn-box">
			<el-button type="primary" size='small' class="fx-big-btn Yahei" v-if="AuthorityList['01_0006_0002_00']" plain @click="add">新建</el-button>
			<el-button type="primary" size='small' class="fx-big-btn Yahei" plain @click="delGoods">删除</el-button>
		</div>
		<div class="main-table-box">
			<MainTable
				ref='table'
				:totalCount='totalCount'
				:tableData='tableData'
				@sizeChange='handleSizeChange'
				@pageChange='handlePageChange'
				@delIds='delIds'
				@delSuc='getList'
				@copySuc='copySuc'
			/>
		</div>
	</div>
</template>

<script>
import Search from '@/components/purchaseOrderSetting/Search.vue'
import MainTable from '@/components/purchaseOrderSetting/MainTable.vue'
export default {
	name: 'purchaseOrderSetting',
	components: {
		Search,
		MainTable
	},
	created () {
		this.getAuthority('01_0006_0000_00')
		this.findShopList()
	},
	data () {
		return {
			shopOptions: [],
			shopid: '',
			sellerShopId: '',
			name: '',
			disabledflag: -1,
			productname: '',
			bcId: 0,
			scId: 0,
			page: 1,
			size: 20,
			totalCount: 0,
			tableData: [],
			ids: '',
			customerName: '',
			shopName: '',
			AuthorityList: {
				'01_0006_0002_00': false
			}
		}
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		findShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
			}).then(res => {
				if (res.result) {
					if (res.data.shop.length > 0) {
						this.shopOptions = res.data.shop
						if (window.sessionStorage.getItem('shopid')) {
							this.shopid = window.sessionStorage.getItem('shopid')
						} else {
							this.shopid = res.data.shop[0].shopId
							window.sessionStorage.setItem('shopid', this.shopid)
							this.sellerShopId = res.data.shop[0].organid
						}
						this.getList()
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		shopChange (item) {
			this.shopOptions.forEach(e => {
				if (item === e.organid) {
					this.shopid = e.shopId
				}
			})
			window.sessionStorage.setItem('shopid', this.shopid)
			this.getList()
		},
		getList () {
			let params = {
				shopName: this.shopName,
				customerName: this.customerName,
				name: this.name,
				disabledflag: this.disabledflag,
				bcId: this.bcId,
				scId: this.scId,
				productname: this.productname,
				page: this.page,
				size: this.size,
				shopId: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/list`,
				data: params
			}).then(res => {
				if (res.result) {
					res.data.list.forEach(item => {
						item.disabledflag = item.disabledflag ? '停用' : '启用'
					})
					this.tableData = res.data.list
					this.$nextTick(() => {
						this.$refs.table.initTableData()
					})
					this.totalCount = res.data.count
				}
			})
		},
		copySuc () {
			this.getList()
		},
		delIds (data) {
			this.ids = data.join(',')
		},
		delGoods () {
			if (this.ids === '') {
				this.$message.error('请至少选择一个常购单！')
				return false
			}
			this.$confirm('是否删除常购单？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					listidArr: this.ids
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/delete`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.getList()
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		handleSizeChange (value) {
			this.size = value
			this.getList()
		},
		handlePageChange (value) {
			this.page = value
			this.getList()
		},
		handleSearch (value) {
			this.$refs.table.clear()
			this.name = value.name
			this.disabledflag = value.disabledflag
			this.productname = value.productname
			this.shopName = value.shopName
			this.customerName = value.customerName
			this.bcId = value.bcId
			this.scId = value.scId
			this.getList()
		},
		add () {
			this.$router.push('/main/purchaseOrder')
		}
	}
}
</script>

<style lang="stylus" scoped>
.purchase-order-setting {
	display flex;
	flex-direction column;
	height: 100%;
	min-height: 0;
	.current-shop-name {
		display: flex;
		align-items: center;
		height: 60px;
		min-height: 0;
		border-bottom: 1px solid #dce2fd;
	}
	.features-btn-box {
		text-align left
		padding 20px 0
		box-sizing border-box
		display: flex;
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 10px;
			display: flex;
			width: 80px;
			height: 32px;
			justify-content center;
			align-items center;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
	.main-table-box {
		flex: 1;
		display flex;
		min-height: 0;
	}
	.Yahei {
		font-family: 'Microsoft Yahei'
	}
}
</style>
